export const MEDIA_PLAYBACK = "Media Playback";
export const NAVIGATION = "Navigation";
export const PRESENTATION = "Presentation";
